export type SiteBuildManifest = {
  buildId: string;
  builtAt: string;
  siteEnv: string;
};

/** Baked at build time (see package.json `NEXT_PUBLIC_BUILD_*`). */
export function getBuildId(): string {
  const id = process.env.NEXT_PUBLIC_BUILD_ID?.trim();
  if (id) return id;
  if (process.env.NODE_ENV === "development") return "development";
  return "unknown";
}

export function getBuildTime(): string {
  const builtAt = process.env.NEXT_PUBLIC_BUILD_TIME?.trim();
  if (builtAt) return builtAt;
  if (process.env.NODE_ENV === "development") return "development";
  return "";
}

export function getSiteEnvLabel(): string {
  const env =
    process.env.NEXT_PUBLIC_SITE_ENV?.trim() ||
    process.env.SITE_ENV?.trim() ||
    process.env.NODE_ENV ||
    "production";
  return env;
}

export function getSiteBuildManifest(): SiteBuildManifest {
  return {
    buildId: getBuildId(),
    builtAt: getBuildTime(),
    siteEnv: getSiteEnvLabel(),
  };
}
